import { SmartrrExtensionsConfig } from "@smartrr/shared/extensions/config";

const windowAny = window as any;

export const extensionsConfig: SmartrrExtensionsConfig | null = windowAny.smartrrExtensionsConfig ?? null;
